import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlayCircleFilled = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12 2.25C6.61479 2.25 2.25 6.61479 2.25 12C2.25 17.3852 6.61479 21.75 12 21.75C17.3852 21.75 21.75 17.3852 21.75 12C21.75 6.61479 17.3852 2.25 12 2.25ZM9.05899 9.70396C9.05899 8.54324 10.3219 7.82013 11.3228 8.41242L15.2048 10.7084C16.1869 11.2888 16.1867 12.7105 15.2044 13.2907L11.3228 15.5865C10.3219 16.1788 9.05899 15.4557 9.05899 14.295V9.70396Z",
		fill: "#323232"
	})
});
const ForwardRef = forwardRef(SvgPlayCircleFilled);
export default ForwardRef;
